// Environment detection
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;
const mode = import.meta.env.MODE; // 'development', 'production', etc.

// Module-local: `getApiUrl` below is its only consumer. Export it again only
// for a reader outside this file.
const API_CONFIG = {
  BASE_URL:
    import.meta.env.VITE_API_BASE_URL ||
    "https://prod.api.dashpet.getdashmote.com",
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || "production",
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === "true" || isProduction,

  // Environment flags
  IS_DEVELOPMENT: isDevelopment,
  IS_PRODUCTION: isProduction,
  MODE: mode,
};

// Environment-specific configurations
export const getApiUrl = (endpoint = "") => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
